import { render, staticRenderFns } from "./customerAddress.vue?vue&type=template&id=e451c82e&scoped=true"
import script from "./customerAddress.vue?vue&type=script&lang=js"
export * from "./customerAddress.vue?vue&type=script&lang=js"
import style0 from "./customerAddress.vue?vue&type=style&index=0&id=e451c82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e451c82e",
  null
  
)

export default component.exports